.link {
  display: inline-flex;
  align-items: flex-start;
  gap: 7px;
  max-width: 100%;
  min-height: var(--target-min);
  padding: 2px 0;
  border-radius: var(--radius-ctl);
  color: var(--accent);
  text-decoration: none;
}

.icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--muted);
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.name {
  overflow-wrap: anywhere;
  font-weight: 650;
}

.secondary {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 400;
}

.link:hover .name,
.link:focus-visible .name {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.link:hover {
  color: var(--accent-h);
}

.link:hover .icon,
.link:focus-visible .icon {
  color: var(--accent);
}

@media (width <= 900px) {
  .link {
    min-height: var(--target-touch);
  }
}
